/**
 * @desc 通过shipment获取SKU信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.allocationMaster.getSkuInfoByShipment.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/allocationMaster/getSkuInfoByShipment`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
